import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AiPreviewUploader from "../components/AiPreviewUploader";
import { useLanguage } from "../context/LanguageContext";

export default function AiPreview() {
  const { t } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location.key]);

  return (
    <section className="ai-preview-page relative max-w-full overflow-x-hidden bg-gradient-to-br from-slate-50 via-white to-white px-0 pb-16 pt-10 dark:from-[#070b12] dark:via-[#070b12] dark:to-emerald-950/20 sm:pb-20">
      <div className="container-width max-w-full">
        <div className="mb-8 max-w-3xl min-w-0">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#66C95E]">
            {t("aiPreview.badge")}
          </p>
          <h1 className="mt-4 text-4xl font-bold leading-tight text-slate-900 dark:text-white sm:text-5xl">
            {t("aiPreview.title")}
          </h1>
          <p className="mt-4 max-w-full text-lg text-slate-600 dark:text-white/65">
            {t("aiPreview.subtitle")}
          </p>
        </div>

        <AiPreviewUploader />
      </div>
    </section>
  );
}
